import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User } from '@loyalty-v3/libs';
import { Store } from '@ngrx/store';
import { domain } from '@stores/partner/partner.selectors';
import { selectOnceIfDefined } from '@stores/utils/selects.operators';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserV3WebService {
  readonly #store = inject(Store);
  readonly #http = inject(HttpClient);
  readonly #baseUrl$ = selectOnceIfDefined(this.#store, domain).pipe(
    map((partnerDomain) => `https://d.${partnerDomain}`)
  );

  readonly get = (id: string): Observable<User> =>
    this.#baseUrl$.pipe(switchMap((baseUrl) => this.#http.get<User>(`${baseUrl}/v1/user/${id}/overview`)));
}
